import { Routes } from '@angular/router';
import { LoginPageComponent } from './content/pages-new-design/auth-page/login-page/login-page.component';
import { AuthGuardService } from './services/authGuard.service';
import {
  ResetPasswordPageComponent
} from './content/pages-new-design/auth-page/reset-password-page/reset-password-page.component';
import {
  RegisterUserPageComponent
} from './content/pages-new-design/auth-page/register-user-page/register-user-page.component';
import {
  ForgotPasswordPageComponent
} from './content/pages-new-design/auth-page/forgot-password-page/forgot-password-page.component';
import {
  RestorePasswordPageComponent
} from './content/pages-new-design/auth-page/restore-password-page/restore-password-page.component';
import {
  SelectRolePageComponent
} from './content/pages-new-design/auth-page/select-role-page/select-role-page.component';
import {
  KeycloakSessionPageComponent
} from './content/pages-new-design/auth-page/keycloak-session-page/keycloak-session-page.component';

export const RouteDefinitions = {
  inventory: {
    path: 'inventory',
    icon: {
      def: ['fas', 'ambulance']
    }
  }
};

export const appRoutes: Routes = [
  //--------------------------------------------------------------------------------------------------------------------
  /* public routes with BE redirect
   * all changes must be reflected also in IndexController.java
   */
  {
    path: 'registerUser/:uuid',
    component: RegisterUserPageComponent,
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'restorePassword/:uuid',
    component: RestorePasswordPageComponent,
    pathMatch: 'full',
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'keycloak/session/:uuid',
    component: KeycloakSessionPageComponent,
    pathMatch: 'full',
    runGuardsAndResolvers: 'always'
  },
  //--------------------------------------------------------------------------------------------------------------------
  {
    path: 'forgotPassword',
    component: ForgotPasswordPageComponent,
    pathMatch: 'full'
  },
  {
    path: 'resetPassword/:userId',
    component: ResetPasswordPageComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuardService],
    pathMatch: 'full'
  },
  {
    path: 'selectRole',
    component: SelectRolePageComponent,
    canActivate: [AuthGuardService],
    pathMatch: 'full'
  },
  {
    path: 'home',
    runGuardsAndResolvers: 'always',
    loadChildren: () => import('./content/pages-new-design/home-page/home.routes')
      .then(m => m.homeRoutes)
  },
  {
    path: '',
    component: LoginPageComponent,
    runGuardsAndResolvers: 'always',
    pathMatch: 'full'
  },

  {
    path: 'redirect',
    component: LoginPageComponent,
    runGuardsAndResolvers: 'always',
    pathMatch: 'full'
  },
  //endregion new sites => already lazy-loading children
  //--------------------------------------------------------------------------------------------------------------------
  {
    path: '**',
    redirectTo: '/home',
    pathMatch: 'full'
  }
  //--------------------------------------------------------------------------------------------------------------------
];
